import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const THIRD_PARTY: AppRouteRecordRaw = {
  path: '/third-party',
  name: 'third-party',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '三方平台管理',
    icon: 'icon-link',
    requiresAuth: true,
    order: 9,
  },
  children: [
    {
      path: 'platform',
      name: 'ThirdPartyPlatform',
      component: () => import('@/views/third-party/platform/index.vue'),
      meta: {
        locale: '三方平台站点列表',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'server',
      name: 'ThirdPartyServerRedirect',
      redirect: '/forward/server',
      meta: {
        locale: '三方服务器管理',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'wechat-mini',
      name: 'WechatMiniProgram',
      component: () => import('@/views/third-party/wechat-mini/index.vue'),
      meta: {
        locale: '小程序授权发布',
        requiresAuth: true,
        roles: ['*'],
        superAdminOnly: true,
      },
    },
  ],
};

export default THIRD_PARTY;
